import React from "react";
import Section1 from "./Section1";
import Section2 from "./Section2";
import Section3 from "./Section3";
import Section4 from "./Section4";
import Section5 from "./Section5";
import Section6 from "./Section6";
import { Helmet } from "react-helmet";

const MBGPage = () => {
  return (
    <>
     <Helmet>
        <title>MBG - Mean3 Software Solutions</title>
      </Helmet>
      <div>
        <Section1 />
      </div>
      <div className="bg-gray-100">
        <Section2 />
        <Section3 />
        <Section4/>
        <Section5/>
        <Section6/>
      </div>
    </>
  );
};

export default MBGPage;
